module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.ed4af93.woff2";